/**
 * theme-dev.js
 * Custom JS for awan-kids theme: product card color swatch image swap,
 * size availability update, and AJAX add-to-cart for Color+Size products.
 */
(function () {
  'use strict';

  function getCardData(card) {
    const script = card.querySelector('.product-card-variants-json');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function findOptionIndex(options, keyword) {
    return options.findIndex(function (opt) {
      var name = opt.name.toLowerCase();
      return name.includes(keyword);
    });
  }

  function generateSrcset(url) {
    var widths = [180, 360, 540, 720, 900];
    return widths
      .map(function (w) {
        return url.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
      })
      .join(', ');
  }

  // --- Color Swatch: Image Swap ---
  document.addEventListener('click', function (e) {
    var swatchBtn = e.target.closest('.product-card__bottom button.color-swatch');
    if (!swatchBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var card = swatchBtn.closest('.product-card');
    if (!card) return;

    var newImageUrl = swatchBtn.getAttribute('data-variant-image');
    var colorValue = swatchBtn.getAttribute('data-color-value');

    // Update active swatch state
    card
      .querySelectorAll('.product-card__bottom button.color-swatch')
      .forEach(function (s) {
        s.classList.remove('is-active');
      });
    swatchBtn.classList.add('is-active');

    // Swap the main product image
    if (newImageUrl) {
      var mainImg = card.querySelector(
        '.product-card__media > a > img'
      );
      if (mainImg) {
        mainImg.src = newImageUrl;
        mainImg.srcset = generateSrcset(newImageUrl);
      }
    }

    // Update size button availability for selected color
    updateSizeAvailability(card, colorValue);

    // Mobile: show size overlay after selecting color
    if (window.matchMedia('(max-width: 767px)').matches) {
      var sizeOverlay = card.querySelector('.quick-add--sizes .buttons');
      if (sizeOverlay) {
        sizeOverlay.classList.add('mobile-visible');
      }
    }
  });

  function updateSizeAvailability(card, selectedColor) {
    var data = getCardData(card);
    if (!data) return;

    var colorIdx = findOptionIndex(data.options, 'color');
    if (colorIdx === -1) colorIdx = findOptionIndex(data.options, 'colour');
    var sizeIdx = findOptionIndex(data.options, 'size');
    if (sizeIdx === -1) return;

    var sizeButtons = card.querySelectorAll(
      '.quick-add--sizes .size-swatch-btn'
    );
    sizeButtons.forEach(function (btn) {
      var sizeVal = btn.getAttribute('data-size-value');
      var matchingVariant = data.variants.find(function (v) {
        return (
          v.options[colorIdx] === selectedColor &&
          v.options[sizeIdx] === sizeVal
        );
      });

      if (matchingVariant && matchingVariant.available) {
        btn.disabled = false;
        btn.style.display = '';
      } else {
        btn.disabled = true;
        btn.style.display = 'none';
      }
    });
  }

  // --- Size Button: AJAX Add to Cart (for Color+Size products) ---
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('.quick-add--sizes .size-swatch-btn');
    if (!sizeBtn || sizeBtn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var card = sizeBtn.closest('.product-card');
    if (!card) return;

    var data = getCardData(card);
    if (!data) return;

    var activeSwatch = card.querySelector(
      '.product-card__bottom button.color-swatch.is-active'
    );
    var selectedColor = activeSwatch
      ? activeSwatch.getAttribute('data-color-value')
      : null;
    var selectedSize = sizeBtn.getAttribute('data-size-value');

    var colorIdx = findOptionIndex(data.options, 'color');
    if (colorIdx === -1) colorIdx = findOptionIndex(data.options, 'colour');
    var sizeIdx = findOptionIndex(data.options, 'size');

    var variant = data.variants.find(function (v) {
      var colorMatch =
        colorIdx === -1 || v.options[colorIdx] === selectedColor;
      return colorMatch && v.options[sizeIdx] === selectedSize;
    });

    if (!variant || !variant.available) return;

    // Disable button during request
    sizeBtn.setAttribute('aria-disabled', 'true');
    sizeBtn.setAttribute('aria-busy', 'true');

    // Collect bundled sections (same pattern as theme's ProductForm)
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    var formData = new FormData();
    formData.append('id', variant.id);
    formData.append('quantity', 1);
    formData.append('sections', sectionsToBundle);
    formData.append('sections_url', window.location.pathname);

    var config = theme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(theme.routes.cart_add_url, config)
      .then(function (res) {
        return res.json();
      })
      .then(async function (parsedState) {
        if (parsedState.status) {
          // Error (e.g., sold out race condition)
          sizeBtn.classList.add('is-disabled');
          sizeBtn.disabled = true;
          return;
        }

        // Success - update cart using theme's pubsub
        var cartJson = await (
          await fetch(theme.routes.cart_url, {
            ...theme.utils.fetchConfig('json', 'GET'),
          })
        ).json();
        cartJson['sections'] = parsedState['sections'];

        theme.pubsub.publish(
          theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          {
            source: 'product-form',
            productVariantId: variant.id,
            cart: cartJson,
          }
        );
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: { product: parsedState },
          })
        );

        // Open cart drawer
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.show(sizeBtn);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        sizeBtn.removeAttribute('aria-disabled');
        sizeBtn.removeAttribute('aria-busy');
      });
  });

  // --- Mobile: Size Overlay Toggle for Size-only products ---
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.size-overlay-trigger');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    var card = trigger.closest('.product-card');
    if (!card) return;

    var sizeOverlay = card.querySelector('.quick-add--sizes .buttons');
    if (sizeOverlay) {
      sizeOverlay.classList.toggle('mobile-visible');
    }
  });

  // --- Close mobile size overlay when clicking outside ---
  document.addEventListener('click', function (e) {
    if (!window.matchMedia('(max-width: 767px)').matches) return;

    var openOverlays = document.querySelectorAll(
      '.quick-add--sizes .buttons.mobile-visible'
    );
    openOverlays.forEach(function (overlay) {
      var card = overlay.closest('.product-card');
      if (card && !card.contains(e.target)) {
        overlay.classList.remove('mobile-visible');
      }
    });
  });

  // --- BIS app drawer wrap (MST 'Now In Stock' → native drawer UI) ---
  // Moves the MST app's `.iStock-wrapper` inline card into the native
  // `<back-in-stock-drawer data-bis-source="mst-app">` shell rendered by
  // snippets/buy-buttons.liquid, so the app inherits the theme's drawer
  // visuals while keeping the app's backend intact (email submit + restock
  // auto-notify). MST's event binding on `.iStock-notify-btn` survives the
  // DOM move because `appendChild` preserves listeners.
  //
  // Trigger button visibility is mirrored to MST wrapper display state via
  // MutationObserver on the wrapper's `style` attribute. When variant switches
  // between OOS and in-stock, MST toggles wrapper display; observer syncs
  // trigger button `hidden` attribute accordingly.
  (function bisAppDrawer() {
    function moveIntoDrawer() {
      var slot = document.querySelector(
        'back-in-stock-drawer[data-bis-source="mst-app"] [data-bis-app-slot]'
      );
      var wrapper = document.querySelector('.iStock-wrapper');
      if (!slot || !wrapper) return false;
      if (slot.contains(wrapper)) return true;
      slot.appendChild(wrapper);
      return true;
    }

    function syncTriggerVisibility() {
      var triggers = document.querySelectorAll('[data-bis-app-trigger]');
      if (!triggers.length) return;
      var wrapper = document.querySelector('.iStock-wrapper');
      var isShown = !!wrapper && wrapper.style.display === 'block';
      triggers.forEach(function (btn) {
        btn.hidden = !isShown;
      });
    }

    function observeWrapper() {
      var wrapper = document.querySelector('.iStock-wrapper');
      if (!wrapper) return;
      if (wrapper.__bisObserved) return;
      wrapper.__bisObserved = true;
      var observer = new MutationObserver(syncTriggerVisibility);
      observer.observe(wrapper, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }

    // Skip if no BIS app drawer on this page (setting off or non-product page).
    if (
      !document.querySelector('back-in-stock-drawer[data-bis-source="mst-app"]')
    ) {
      return;
    }

    // Patch MST's variant-id lookups so calls targeting our app-wrap drawer
    // always use the MAIN product form's current variant id. Two paths need
    // patching because MST resolves the variant id from two different sources:
    //
    // 1. `istockNotifyShow(product, vId, wrapper)` — display toggle. MST's
    //    init loop iterates all `[name=id]` on the page (70+ on a PDP with
    //    recommendations/quick-add cards) and, via its ancestor walk on our
    //    single `.iStock-wrapper`, associates the wrong quick-add card's
    //    variant id — early-return with the wrapper hidden. Fix: override
    //    the `vId` argument when `wrapper` is inside our drawer.
    //
    // 2. `istockNotifyMe(button)` — submit handler. Calls
    //    `findAncestor(button, this.varSelector)` internally to get vId.
    //    Native `DrawerElement.show()` REPARENTS the drawer to <body> on
    //    open (for stacking-context isolation), so at submit time the
    //    ancestor walk from our button no longer passes through
    //    `.product-form-wrapper` — it goes drawer → body directly. First
    //    `[name=id]` at body level is some other product's variant, causing
    //    the POST to /add_notify.php to send `vid=undefined` (because MST
    //    calls `.id` on the `false` returned by `istockGetVariant`), server
    //    responds with `{"insertId":0}`, and no success message shows. Fix:
    //    patch `iStock.findAncestor` to short-circuit varSelector lookups
    //    when called from an element inside our drawer, returning the main
    //    form's `[name=id]` directly.
    //
    // Idempotent: only wraps once (guarded by `__bisPatched` flag).
    function patchIstockLookups() {
      if (!window.iStock || window.iStock.__bisPatched) return false;

      function mainFormVariantInput() {
        return document.querySelector(
          'product-info form[action*="/cart/add"] [name=id]'
        );
      }

      // Path 1: display toggle
      var origShow = window.iStock.istockNotifyShow.bind(window.iStock);
      window.iStock.istockNotifyShow = function (product, vId, wrapper) {
        if (
          wrapper &&
          wrapper.closest &&
          wrapper.closest(
            'back-in-stock-drawer[data-bis-source="mst-app"]'
          )
        ) {
          var mainInput = mainFormVariantInput();
          if (mainInput && mainInput.value) {
            vId = mainInput.value;
          }
        }
        return origShow(product, vId, wrapper);
      };

      // Path 2: submit path (via findAncestor). Only intercept when caller
      // is looking for the variant selector AND from within our drawer —
      // leaves wrapper lookup (`.iStock-wrapper`) and non-app-drawer usage
      // untouched.
      var origFindAncestor = window.iStock.findAncestor.bind(window.iStock);
      window.iStock.findAncestor = function (el, cls) {
        if (
          cls === this.varSelector &&
          el &&
          el.closest &&
          el.closest('back-in-stock-drawer[data-bis-source="mst-app"]')
        ) {
          var mainInput = mainFormVariantInput();
          if (mainInput) return mainInput;
        }
        return origFindAncestor(el, cls);
      };

      window.iStock.__bisPatched = true;
      return true;
    }

    // Chain into MST's post-init callback. MST calls window.istockInitFn once
    // at end of iStock.init() (see iStock-notify-2.0.1.js line ~350).
    var prevInitFn = window.istockInitFn;
    window.istockInitFn = function () {
      if (typeof prevInitFn === 'function') {
        try {
          prevInitFn();
        } catch (e) {}
      }
      patchIstockLookups();
      moveIntoDrawer();
      observeWrapper();
      syncTriggerVisibility();
    };

    // Fallback poll — if MST init timing shifts or callback fails to fire,
    // catch up within ~5s. Idempotent: `moveIntoDrawer` early-returns once done.
    var attempts = 0;
    var maxAttempts = 20;
    var interval = setInterval(function () {
      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(interval);
        return;
      }
      if (moveIntoDrawer()) {
        patchIstockLookups();
        observeWrapper();
        syncTriggerVisibility();
        clearInterval(interval);
      }
    }, 250);
  })();
})();
